import { defineComponent as _defineComponent } from 'vue'
import Avatar from '@sh/components/Layout/Header/HeaderV2/Avatar.ts.vue';
import TutorialDropdown from '@sh/components/Layout/TutorialDropdown/TutorialDropdown.ts.vue';
import GlobalSearch from '@sh/components/Utils/Search/GlobalSearch.vue';
import session from '@sh/services/session';
import { User } from '@sh/types';
import { getCurrentInstance } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderV2.ts',
  setup(__props) {

const instance = getCurrentInstance();
const router = instance?.proxy.$router;
const user = session?.getUser();
const domWindow = window as typeof window & { dataLayer: any[]; user?: User };

// expose user data to the global window object
function exposeUser() {
  const user = session?.getUser();
  if (user) domWindow.user = user;
}

// On Authentication hook
session.afterAuthentication(() => {
  exposeUser();
}, 'once');

session.afterLogout(() => {
  delete domWindow.user;
}, 'once');

// On page reload
if (session.isAuthenticated()) {
  exposeUser();
}

function logOut() {
  session.removeToken();
  router?.push({ name: 'Login' });
}

return { __sfc: true,instance, router, user, domWindow, exposeUser, logOut, Avatar, TutorialDropdown, GlobalSearch, session }
}

})